var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V30H0V0Z",
    fill: "#E2E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4063 18.096C31.081 18.8733 32.093 19.4306 32.8557 19.4306C34.0583 19.4306 34.8943 18.8146 34.8943 17.9493C34.8943 16.072 29.057 17.2453 29.057 13.3C29.057 11.4373 30.685 10.132 33.0023 10.132C34.293 10.132 35.7743 10.8213 36.6103 11.8186L34.997 13.124C34.4543 12.4786 33.633 12.024 33.0023 12.024C31.9903 12.024 31.2863 12.552 31.2863 13.3C31.2863 15.1626 37.1237 14.2826 37.1237 17.9493C37.1237 19.9293 35.3637 21.3226 32.8557 21.3226C31.4183 21.3226 29.7317 20.5453 28.7637 19.4306L30.4063 18.096Z",
    fill: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1407 21.3666C20.354 21.3666 18.4033 19.4746 18.4033 16.7759V10.1466H20.6327V16.7466C20.6327 18.3013 21.6007 19.2839 23.1407 19.2839C24.6807 19.2839 25.6487 18.3013 25.6487 16.7466V10.1466H27.878V16.7759C27.878 19.4746 25.9273 21.3666 23.1407 21.3666Z",
    fill: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.197 16.0133C14.2384 16.0133 14.8984 15.2506 14.8984 14.0333C14.8984 12.8159 14.2384 12.0533 13.197 12.0533H10.4984V16.0133H13.197ZM8.26904 21.2639V10.1466H13.681C15.705 10.1466 17.1277 11.7159 17.1277 13.9453C17.1277 15.2653 16.6877 16.5266 14.913 17.5239L17.6557 21.2639H14.8984L12.4344 17.9199H10.4984V21.2639H8.26904Z",
    fill: "#3C3C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRus);
export default __webpack_public_path__ + "static/media/icon_rus.d3602be568908e08703479db08832103.svg";
export { ForwardRef as ReactComponent };